var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M10 19H14V17.1429H10V19ZM6 13.4286H18V11.5714H6V13.4286ZM3 6V7.85714H21V6H3Z"}}),(_vm.title !== '')?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }